module.exports = __webpack_public_path__ + "static/Master_Starnes-e8f70340057151c78a63836e8b584e45.jpg";